import React from 'react';
import { 
  FaChartBar, 
  FaScroll, 
  FaChartLine, 
  FaUsers 
} from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
const Navigation = ({ activeSection, setActiveSection }) => {
  const { user } = useAuth();

  const isSuperAdmin = () => user?.role_id === 1;
  const isAdmin = () => user?.role_id === 2;
  const canManageProverbs = () => isSuperAdmin() || isAdmin();
  const canManageUsers = () => isSuperAdmin();

  return (
    <nav className="nav-tabs">
      <button 
        className={`nav-tab ${activeSection === 'dashboard' ? 'active' : ''}`}
        onClick={() => setActiveSection('dashboard')}
      >
        <FaChartBar /> Dashboard
      </button>
      {canManageProverbs() && (
        <button 
          className={`nav-tab ${activeSection === 'proverbs' ? 'active' : ''}`}
          onClick={() => setActiveSection('proverbs')}
        >
          <FaScroll /> Proverbs
        </button>
      )}
      <button 
        className={`nav-tab ${activeSection === 'analytics' ? 'active' : ''}`}
        onClick={() => setActiveSection('analytics')}
      >
        <FaChartLine /> Analytics
      </button>
      {canManageUsers() && (
        <button 
          className={`nav-tab ${activeSection === 'users' ? 'active' : ''}`}
          onClick={() => setActiveSection('users')}
        >
          <FaUsers /> Users
        </button>
      )}
    </nav>
  );
};

export default Navigation;
